<template>
  <section class="container content-padding">
    <div class="row" v-if="prices">
      <template v-for="provinceId in provinceIds" >
        <div class="col-md-4" :key="`province_${provinceId}`" v-if="globalState && globalState.cities[provinceId] && prices[provinceId]">
          <div class="card">
            <div class="card-body">
              <div class="price-plan">
                <h3 class="price-city" >{{ globalState.cities[provinceId] | multiLangName }}</h3>
                <p class="price">{{ prices[provinceId][1] | currencyNoDecimal }}<span>/{{ $tc('message.hour', 1.0) }}</span></p>
                <div>{{ $t('message.exclude_vat') }}</div>
              </div><!-- price -->
              <div class="price-plan">
                <ul>
                  <li v-for="workHour in workHours" :key="`${provinceId}_${workHour}`">{{ workHour }} {{ $tc('message.hour', workHour) }} {{ prices[provinceId][workHour] | currencyNoDecimal }}</li>
                </ul>
              </div><!-- detail -->
              <div class="text-center mt--4">
                <router-link to="/booking/start" tag="a" class="btn btn-outline-secondary btn-lg mt-3">
                  {{ $t('message.menu.book_cleaner') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- /.col-md-4 -->
    </div>

    <div class="row">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <p class="text-remark">
                BeNeat (บีนีท) แพลตฟอร์ม
                เป็นเพียงเครื่องมือที่ใช้สำหรับการติดต่อสื่อสารระหว่างผู้ให้บริการกับผู้รับบริการเท่านั้น
                ผู้ให้บริการเป็นผู้รับจ้างอิสระ (ซึ่งไม่ใช่ในฐานะลูกจ้าง คนงาน ตัวแทน ผู้ร่วมทุน หุ้นส่วน หรือ
                ผู้ได้รับสิทธิพิเศษในการให้บริการจากบีนีท อย่างหนึ่งอย่างใดทั้งสิ้น
                บีนีทไม่ได้เป็นผู้ให้บริการและจ้างบุคคลใดให้บริการเช่นว่านั้น
                บทบาทของบีนีทจำกัดเพียงเสนอแพลตฟอร์มเทคโนโลยีให้เป็นเครื่องมือของท่านในการค้นหาผู้ให้บริการมืออาชีพ)
                คุณภาพการให้บริการเป็นความรับผิดชอบทั้งสิ้นของผู้ให้บริการเอง ซึ่งท่านเป็นผู้ว่าจ้าง
                ท่านพึงตระหนักว่าการเรียกใช้บริการจากผู้ให้บริการ อาจมีความเสี่ยง ซึ่งท่านรับทราบและยินดีใช้บริการ
                บนความเสี่ยงใด ๆ ในความรับผิดชอบของตัวท่านเอง
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        prices: null,
        workHours: [],
        provinceIds: [1, 2, 4]
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      async getPrices () {
        const { data } = await axios.get('/prices')
        if (!data.error) {
          this.prices = data.prices
          this.workHours = data.work_hours
        }
      }
    },
    created () {
      this.getPrices()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/information/Pricing.vue